const SWATCH_CHECKMARK_HTML = `<span class="card-product-variant-check" aria-hidden="true">
  <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false">
    <path d="M1 4L3.5 6.5L9 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</span>`;

function getShadeDataFromElement(element) {
  if (!element) return null;

  return {
    productId: element.dataset.productId || '',
    productUrl: element.dataset.productUrl || '',
    productTitle: element.dataset.productTitle || '',
    imageUrl: element.dataset.cardImage || '',
    priceHtml: element.dataset.priceHtml || '',
    ratingHtml: element.dataset.ratingHtml || '',
    subtitle: element.dataset.subtitle || '',
    variantId: element.dataset.variantId || '',
    sku: element.dataset.sku || '',
    varPrice: element.dataset.varPrice || '',
    available: element.dataset.available === 'true'
  };
}

function syncSwatchCheckmark(button, isSelected) {
  if (!button) return;

  const check = button.querySelector('.card-product-variant-check');
  if (isSelected && !check) {
    button.insertAdjacentHTML('beforeend', SWATCH_CHECKMARK_HTML);
  } else if (!isSelected && check) {
    check.remove();
  }
}

function syncInlineSwatchSelection(card, productId) {
  const group = card.querySelector('.card-product-variant-swatches');
  if (!group || !productId) return;

  const activeId = String(productId);

  group.querySelectorAll('.card-product-variant-swatch').forEach((btn) => {
    const isMatch = String(btn.dataset.productId) === activeId;
    btn.classList.toggle('is-selected', isMatch);

    if (isMatch) {
      btn.setAttribute('aria-current', 'true');
    } else {
      btn.removeAttribute('aria-current');
    }

    syncSwatchCheckmark(btn, isMatch);
  });
}

function getCardAtcWrap(card) {
  return card?.querySelector('.hdt-pr13-card__atc-wrap') || null;
}

function getCardAtcButton(card) {
  const wrap = getCardAtcWrap(card);
  if (!wrap) return null;
  return (
    wrap.querySelector('.hdt-pr13-card__atc[name="add"]') ||
    wrap.querySelector('button.hdt-pr13-card__atc') ||
    wrap.querySelector('a.hdt-pr13-card__atc') ||
    wrap.querySelector('.hdt-pr13-card__atc')
  );
}

function ensureCardSoldOutBadge(card) {
  let badge = card.querySelector('.hdt-badge__sold_out');
  if (badge) return badge;

  const media = card.querySelector('.hdt-pr13-card__media');
  if (!media) return null;

  let wrap = media.querySelector('.hdt-badge__wrapp');
  if (!wrap) {
    wrap = document.createElement('div');
    wrap.className = 'hdt-badge__wrapp hdt-pe-none';
    media.prepend(wrap);
  }

  badge = document.createElement('hdt-badge');
  badge.className = 'hdt-badge hdt-badge__sold_out';
  badge.setAttribute('is', 'sold_out');
  badge.innerHTML = `<span>${window.variantStrings?.soldOut || 'Sold out'}</span>`;
  wrap.appendChild(badge);
  return badge;
}

function ensureCardAtcForm(card, data) {
  const wrap = getCardAtcWrap(card);
  if (!wrap || !data?.variantId) return null;

  let atcBtn = wrap.querySelector('.hdt-pr13-card__atc[name="add"]');
  if (atcBtn) return atcBtn;

  const formId = `pr13-shade-form-${card.dataset.activeProductId || data.productId || Date.now()}`;
  const title = data.productTitle || '';
  const productId = data.productId || '';
  const variantId = data.variantId;
  const sku = data.sku || '';
  const varPrice = data.varPrice || '';

  wrap.innerHTML = `
    <wrapp-hdt-pr-frm class="hdt-product-form hdt-pr13-card__form-wrap">
      <form method="post" action="${window.routes?.cart_add_url || '/cart/add'}" id="${formId}" class="hdt-pr13-card__form" accept-charset="UTF-8" enctype="multipart/form-data" novalidate>
        <input type="hidden" name="form_type" value="product">
        <input type="hidden" name="utf8" value="✓">
        <input type="hidden" name="id" value="${variantId}">
        <input type="hidden" name="quantity" value="1">
        <button
          type="submit"
          name="add"
          class="hdt-pr13-card__atc"
          cardselectedprodname="${title.replace(/"/g, '&quot;')}"
          cardselectedvarprice="${String(varPrice).replace(/"/g, '&quot;')}"
          cardselectedprodid="${productId}"
          cardselectedvarid="${variantId}"
          cardselectsku="${sku.replace(/"/g, '&quot;')}"
        >Add to cart</button>
      </form>
    </wrapp-hdt-pr-frm>
  `;

  return wrap.querySelector('.hdt-pr13-card__atc[name="add"]');
}

function syncCardAvailability(card, isAvailable, data = null) {
  if (!card || typeof isAvailable !== 'boolean') return;

  card.classList.toggle('hdt-pr-sold_out', !isAvailable);
  card.classList.toggle('hdt-pr13-card--unavailable', !isAvailable);

  const badge = isAvailable
    ? card.querySelector('.hdt-badge__sold_out')
    : ensureCardSoldOutBadge(card);

  if (badge) {
    badge.hidden = isAvailable;
    if (isAvailable) {
      badge.setAttribute('hidden', '');
    } else {
      badge.removeAttribute('hidden');
    }
  }

  const soldOutLabel = window.variantStrings?.soldOut || 'Sold out';
  const addToCartLabel = window.variantStrings?.addToCart || 'Add to cart';
  const wrap = getCardAtcWrap(card);
  if (!wrap) return;

  let atcBtn = wrap.querySelector('.hdt-pr13-card__atc[name="add"]');

  // Sold-out cards may only have a static <a>; build a real form when in stock.
  if (isAvailable && !atcBtn && data?.variantId) {
    atcBtn = ensureCardAtcForm(card, data);
  }

  if (atcBtn) {
    atcBtn.disabled = !isAvailable;
    if (isAvailable) {
      atcBtn.removeAttribute('disabled');
    } else {
      atcBtn.setAttribute('disabled', '');
    }
    atcBtn.classList.toggle('is-disabled', !isAvailable);
    atcBtn.classList.toggle('hdt-pr13-card__atc--disabled', !isAvailable);
    atcBtn.textContent = isAvailable ? addToCartLabel : soldOutLabel;
    return;
  }

  const atcLink = wrap.querySelector('a.hdt-pr13-card__atc, .hdt-pr13-card__atc');
  if (atcLink) {
    atcLink.classList.toggle('hdt-pr13-card__atc--disabled', !isAvailable);
    atcLink.textContent = isAvailable ? addToCartLabel : soldOutLabel;
    if (isAvailable) {
      atcLink.removeAttribute('aria-disabled');
    } else {
      atcLink.setAttribute('aria-disabled', 'true');
    }
  }
}

function updateProductCardFromShade(card, data) {
  if (!card || !data) return;

  if (data.productId) {
    card.dataset.activeProductId = data.productId;
    syncInlineSwatchSelection(card, data.productId);
  }

  if (data.imageUrl) {
    const img = card.querySelector('.hdt-pr13-card__img');
    if (img) {
      // Shopify image_tag renders srcset; browsers keep using it if left in place,
      // so changing only src leaves the old product image visible.
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = data.imageUrl;
      if (data.productTitle) {
        img.alt = data.productTitle;
      }
    }
  }

  if (data.productUrl) {
    card.querySelectorAll('[data-pr-url]').forEach((link) => {
      // Don't rewrite modal/internal links that aren't product URLs on the card.
      if (link.closest('.card-product-modal')) return;
      link.href = data.productUrl;
    });
  }

  if (data.productTitle) {
    const titleLink = card.querySelector('.hdt-pr13-card__title');
    if (titleLink) {
      titleLink.textContent = data.productTitle;
    }
  }

  if (data.priceHtml) {
    const priceContainer = card.querySelector('.hdt-pr13-card__price');
    if (priceContainer) {
      priceContainer.innerHTML = data.priceHtml;
    }
  }

  if (data.ratingHtml !== undefined) {
    const ratingContainer = card.querySelector('.hdt-pr13-card__rating');
    if (ratingContainer) {
      const ratingHtml = (data.ratingHtml || '').trim();
      const isZeroJdgm =
        /data-number-of-reviews=["']0["']/.test(ratingHtml) ||
        /data-average-rating=["']0(?:\.00)?["']/.test(ratingHtml);
      ratingContainer.innerHTML = ratingHtml;
      ratingContainer.hidden = !ratingHtml || isZeroJdgm;
    }
  }

  const subtitleEl = card.querySelector('.hdt-pr13-card__subtitle');
  if (subtitleEl) {
    if (data.subtitle) {
      subtitleEl.textContent = data.subtitle;
      subtitleEl.hidden = false;
    } else {
      subtitleEl.textContent = '';
      subtitleEl.hidden = true;
    }
  }

  if (data.variantId) {
    const idInput = card.querySelector('.hdt-pr13-card__atc-wrap form.hdt-pr13-card__form input[name="id"]');
    if (idInput) {
      idInput.value = data.variantId;
    }

    const atcBtn = getCardAtcButton(card);
    if (atcBtn && atcBtn.getAttribute('name') === 'add') {
      atcBtn.setAttribute('cardselectedvarid', data.variantId);
      if (data.productTitle) {
        atcBtn.setAttribute('cardselectedprodname', data.productTitle);
      }
      if (data.productId) {
        atcBtn.setAttribute('cardselectedprodid', data.productId);
      }
      if (data.sku) {
        atcBtn.setAttribute('cardselectsku', data.sku);
      }
      if (data.varPrice != null && data.varPrice !== '') {
        atcBtn.setAttribute('cardselectedvarprice', data.varPrice);
      }
    }
    if (data.sku || data.variantId) {
      card.setAttribute('data-item-id', data.sku || data.variantId);
    }
    if (data.productTitle) {
      card.setAttribute('data-item-name', data.productTitle);
    }
    if (data.varPrice != null && data.varPrice !== '') {
      card.setAttribute('data-price', String(data.varPrice).replace(/,/g, ''));
    }
  }

  if (typeof data.available === 'boolean') {
    syncCardAvailability(card, data.available, data);
  }
}

class CardProductVariantSwatches extends HTMLElement {
  connectedCallback() {
    this.modal = this.querySelector('hdt-modal') || (this.dataset.modalId ? document.getElementById(this.dataset.modalId) : null);
    this.ensureUniqueModalIdentity();
    this.refreshModalRefs();
    this.initialSelectedProductId = null;
    this.onVariantAdd = this.handleVariantAdd.bind(this);

    if (!this.modal || !this.options.length) return;

    this.options.forEach((option) => {
      option.addEventListener('click', () => this.selectOption(option));
    });

    document.addEventListener('variant:add', this.onVariantAdd);

    // appendToBody can move the modal; keep a stable handle after open/close.
    this.modal.addEventListener('dialog:beforeOpen', () => {
      this.closeOtherOpenShadeModals();
    });

    this.modal.addEventListener('dialog:afterOpen', () => {
      this.refreshModalRefs();
      this.syncModalFromCard();
    });

    this.modal.addEventListener('dialog:afterClose', () => {
      this.refreshModalRefs();
      this.syncCardFromModalSelection();
    });
  }

  disconnectedCallback() {
    document.removeEventListener('variant:add', this.onVariantAdd);
  }

  /**
   * Theme dialogs bind open handlers by id on document.body.
   * Duplicate modal ids (same product in multiple sliders/tabs) cause every
   * matching dialog to open from one click. Keep each instance unique.
   */
  ensureUniqueModalIdentity() {
    const moreBtn = this.querySelector('.card-product-variant-more');
    if (!this.modal || !moreBtn) return;

    let modalId = this.modal.id || moreBtn.getAttribute('aria-controls') || '';
    if (!modalId) return;

    document.querySelectorAll(`hdt-modal.card-product-modal[id="${modalId}"]`).forEach((el) => {
      if (el === this.modal) return;
      // Stale modals left on body after AJAX tab refreshes + appendToBody.
      if (!el.hasAttribute('open') && el.parentElement === document.body) {
        el.remove();
      }
    });

    const hasConflict = Array.from(document.querySelectorAll(`hdt-modal.card-product-modal[id="${modalId}"]`))
      .some((el) => el !== this.modal);

    if (hasConflict) {
      modalId = `${modalId}-${Math.random().toString(36).slice(2, 9)}`;
      this.modal.id = modalId;
    } else if (!this.modal.id) {
      this.modal.id = modalId;
    }

    moreBtn.setAttribute('aria-controls', this.modal.id);
    this.dataset.modalId = this.modal.id;
  }

  closeOtherOpenShadeModals() {
    document.querySelectorAll('hdt-modal.card-product-modal[open], hdt-modal.card-product-modal[open-dialog]').forEach((modal) => {
      if (modal === this.modal) return;
      if (typeof modal.closeDialog === 'function') {
        modal.closeDialog(false);
      } else {
        modal.removeAttribute('open');
        modal.removeAttribute('open-dialog');
      }
    });
  }

  refreshModalRefs() {
    if (!this.modal) return;

    this.options = Array.from(this.modal.querySelectorAll('.card-product-modal-option'));
    this.atcBtn = this.modal.querySelector('[data-shade-atc]');
    this.variantInput = this.modal.querySelector('[data-shade-variant-input]');
    this.previewImg = this.modal.querySelector('[data-shade-preview-img]');
    this.previewTitle = this.modal.querySelector('[data-shade-preview-title]');
    this.previewPrice = this.modal.querySelector('[data-shade-preview-price]');
  }

  isModalOpen() {
    if (!this.modal) return false;
    return this.modal.hasAttribute('open') || this.modal.hasAttribute('open-dialog') || this.modal.open === true;
  }

  handleVariantAdd(event) {
    if (!this.isModalOpen()) return;

    const activeVariantId = String(
      this.variantInput?.value || this.atcBtn?.getAttribute('cardselectedvarid') || ''
    );
    if (!activeVariantId) return;

    const items = event.detail?.items || [];
    const matched = items.some((item) => {
      const itemVariantId = String(item?.id || item?.variant_id || '');
      return itemVariantId === activeVariantId;
    });

    if (matched) {
      this.closeModal();
    }
  }

  findOptionByProductId(productId) {
    if (!productId) return null;
    const activeId = String(productId);
    return this.options.find((option) => String(option.dataset.productId) === activeId) || null;
  }

  getSelectedModalOption() {
    return this.options.find((option) => option.classList.contains('is-selected')) || null;
  }

  getActiveProductId(card) {
    if (card?.dataset.activeProductId) {
      return card.dataset.activeProductId;
    }

    const activeSwatch = card?.querySelector('.card-product-variant-swatch.is-selected, .card-product-variant-swatch[aria-current="true"]');
    if (activeSwatch?.dataset.productId) {
      return activeSwatch.dataset.productId;
    }

    const atcBtn = card?.querySelector('.hdt-pr13-card__atc[cardselectedprodid]');
    if (atcBtn?.getAttribute('cardselectedprodid')) {
      return atcBtn.getAttribute('cardselectedprodid');
    }

    return this.dataset.cardProductId || null;
  }

  syncModalOptionSelection(selectedOption) {
    this.options.forEach((option) => {
      const isMatch = option === selectedOption;
      option.classList.toggle('is-selected', isMatch);
      option.setAttribute('aria-pressed', isMatch ? 'true' : 'false');

      const swatchEl = option.querySelector('.card-product-modal-option-swatch');
      syncSwatchCheckmark(swatchEl, isMatch);
    });
  }

  syncModalFromCard() {
    const card = this.closest('hdt-card-product');
    const activeProductId = this.getActiveProductId(card);
    const matchedOption =
      this.findOptionByProductId(activeProductId) ||
      this.getSelectedModalOption() ||
      this.options[0];

    if (matchedOption) {
      this.selectOption(matchedOption, { updateInitial: true });
      return;
    }

    this.initialSelectedProductId = activeProductId;
  }

  selectOption(option, { updateInitial = false } = {}) {
    this.syncModalOptionSelection(option);

    const image = option.dataset.popupImage || '';
    const title = option.dataset.productTitle || '';
    const price = option.dataset.priceFormatted || '';
    const variantId = option.dataset.variantId || '';
    const productId = option.dataset.productId || '';
    const varPrice = option.dataset.varPrice || '';
    const sku = option.dataset.sku || '';
    const isAvailable = option.dataset.available === 'true';

    if (this.previewImg) {
      if (image) {
        this.previewImg.src = image;
        this.previewImg.alt = title;
        this.previewImg.hidden = false;
      } else {
        this.previewImg.hidden = true;
      }
    }

    if (this.previewTitle) this.previewTitle.textContent = title;
    if (this.previewPrice) this.previewPrice.textContent = price;

    if (this.variantInput) {
      this.variantInput.value = variantId;
    }

    if (this.atcBtn) {
      this.atcBtn.setAttribute('cardselectedprodname', title);
      this.atcBtn.setAttribute('cardselectedvarprice', varPrice);
      this.atcBtn.setAttribute('cardselectedprodid', productId);
      this.atcBtn.setAttribute('cardselectedvarid', variantId);
      this.atcBtn.setAttribute('cardselectsku', sku);
      this.atcBtn.disabled = !isAvailable;
      this.atcBtn.classList.toggle('is-disabled', !isAvailable);
      this.atcBtn.textContent = isAvailable
        ? (window.variantStrings?.addToCart || 'Add to cart')
        : (window.variantStrings?.soldOut || 'Sold out');
    }

    const card = this.closest('hdt-card-product');
    if (card) {
      if (sku || variantId) card.setAttribute('data-item-id', sku || variantId);
      if (title) card.setAttribute('data-item-name', title);
      if (varPrice !== '') card.setAttribute('data-price', String(varPrice).replace(/,/g, ''));
    }

    if (updateInitial) {
      this.initialSelectedProductId = productId || null;
    }
  }

  syncCardFromModalSelection() {
    const selected = this.getSelectedModalOption();
    if (!selected) return;

    const selectedProductId = selected.dataset.productId;
    if (!selectedProductId || String(selectedProductId) === String(this.initialSelectedProductId)) return;

    const card = this.closest('hdt-card-product');
    if (!card) return;

    const inlineSwatch = card.querySelector(`.card-product-variant-swatch[data-product-id="${selectedProductId}"]`);
    const shadeData = getShadeDataFromElement(inlineSwatch || selected);

    // Always use the product featured image for the card, never the popup image.
    shadeData.imageUrl = selected.dataset.cardImage || shadeData.imageUrl;

    updateProductCardFromShade(card, shadeData);
  }

  closeModal() {
    if (!this.modal) return;

    if (typeof this.modal.hide === 'function') {
      this.modal.hide();
      return;
    }

    if (typeof this.modal.close === 'function') {
      this.modal.close();
      return;
    }

    this.modal.removeAttribute('open');
    this.modal.removeAttribute('open-dialog');
    this.modal.classList.add('hdt-hidden');
  }
}

if (!customElements.get('card-product-variant-swatches')) {
  customElements.define('card-product-variant-swatches', CardProductVariantSwatches);
}

document.addEventListener('click', (event) => {
  const swatch = event.target.closest('.card-product-variant-swatch');
  if (!swatch) return;

  const card = swatch.closest('hdt-card-product');
  if (!card) return;

  event.preventDefault();
  updateProductCardFromShade(card, getShadeDataFromElement(swatch));
});

/**
 * Per-row swatch slot alignment on PLP grids:
 * - If any product in a visual row has swatches → reserve space on every card in that row
 * - If none do → collapse the empty swatch slot (CSS .is-empty { display: none })
 */
function cardHasSwatches(card) {
  const slot = card.querySelector('.card-product-variant-swatches');
  if (!slot) return false;
  if (slot.dataset.hasSwatches === 'true') return true;
  return Boolean(slot.querySelector('.card-product-variant-swatch'));
}

function syncPlpRowSwatchSpace(root = document) {
  const grids = root.querySelectorAll('.hdt-collection-products.hdt-row-grid');

  grids.forEach((grid) => {
    const cards = Array.from(grid.querySelectorAll(':scope > .hdt-card-product'));
    if (!cards.length) return;

    cards.forEach((card) => card.classList.remove('plp-row-has-swatches'));

    const rows = [];
    cards.forEach((card) => {
      const top = Math.round(card.getBoundingClientRect().top);
      const lastRow = rows[rows.length - 1];
      if (lastRow && Math.abs(lastRow.top - top) <= 2) {
        lastRow.cards.push(card);
      } else {
        rows.push({ top, cards: [card] });
      }
    });

    rows.forEach((row) => {
      const hasSwatches = row.cards.some(cardHasSwatches);
      if (!hasSwatches) return;
      row.cards.forEach((card) => card.classList.add('plp-row-has-swatches'));
    });
  });
}

let plpSwatchSpaceRaf = 0;
function schedulePlpRowSwatchSpace() {
  if (plpSwatchSpaceRaf) cancelAnimationFrame(plpSwatchSpaceRaf);
  plpSwatchSpaceRaf = requestAnimationFrame(() => {
    plpSwatchSpaceRaf = 0;
    syncPlpRowSwatchSpace();
  });
}

function initPlpRowSwatchSpace() {
  syncPlpRowSwatchSpace();
  window.addEventListener('resize', schedulePlpRowSwatchSpace);
  document.addEventListener('facet:render', () => {
    // Facet HTML swap finishes after the event; wait a tick for layout.
    requestAnimationFrame(schedulePlpRowSwatchSpace);
    setTimeout(syncPlpRowSwatchSpace, 50);
    setTimeout(syncPlpRowSwatchSpace, 250);
  });

  // Load-more appends + layout-switch column class changes.
  const observer = new MutationObserver(schedulePlpRowSwatchSpace);
  const observeGrids = () => {
    document.querySelectorAll('.hdt-collection-products.hdt-row-grid').forEach((grid) => {
      if (grid.dataset.plpSwatchObserved === 'true') return;
      grid.dataset.plpSwatchObserved = 'true';
      observer.observe(grid, {
        childList: true,
        attributes: true,
        attributeFilter: ['class']
      });
    });
  };
  observeGrids();
  document.addEventListener('facet:render', () => setTimeout(observeGrids, 60));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPlpRowSwatchSpace);
} else {
  initPlpRowSwatchSpace();
}
